import Joi from 'joi';

export const responseSchema = Joi.object({
  info: Joi.object({
    cost: Joi.number().allow(''),
    quantity: Joi.number().allow(''),
  }),
});
